/* ----------------------------------------
 * i18n （多言語対応）
 *-----------------------------------------*/
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/trials/store';

import jaLocale from './ja';
import enLocale from './en';

import enValidationMessages from 'vee-validate/dist/locale/en';
import jaValidationMessages from 'vee-validate/dist/locale/ja';

Vue.use(VueI18n);

const messages = {
    ja: {
        ...jaLocale,
        validations: jaValidationMessages,
    },
    en: {
        ...enLocale,
        validations: enValidationMessages,
    },
};

const i18n = new VueI18n({
    locale: 'ja',
    fallbackLocale: 'ja',
    messages,
});

export default i18n;
